import styled from 'styled-components';

/* A capa padrão das páginas internas: foto de fundo, véu verde da Copasul,
   breadcrumb no alto e título embaixo à esquerda. Uma altura só para o site
   inteiro (o meio-termo entre as capas antigas, ~530px, e a da Nossa História,
   ~680px): 352px no mínimo, 560px no máximo. A Home tem o carrossel próprio. */

export const Capa = styled.section`
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: clamp(22rem, 30vw, 35rem);
  overflow: hidden;
  /* Por baixo da foto enquanto ela pinta (sem foto a Capa nem aparece: ver
     SoTrilha). */
  background: linear-gradient(110deg, #00893a 0%, #0f4e2b 55%, #0a3a1f 100%);
  color: #fff;
  text-align: left;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;

  > img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Véu: escurece de baixo para cima e da esquerda para a direita, onde fica o
     texto, e deixa a foto respirar no resto. */
  &::before,
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  &::before {
    background: linear-gradient(0deg, rgba(10, 58, 31, 0.9) 0%, rgba(10, 58, 31, 0.55) 40%, rgba(10, 58, 31, 0.12) 100%);
  }

  &::after {
    background: linear-gradient(90deg, rgba(10, 58, 31, 0.7) 0%, rgba(10, 58, 31, 0.35) 45%, rgba(10, 58, 31, 0) 75%);

    @media (max-width: 900px) {
      background: rgba(10, 58, 31, 0.45);
    }
  }
`;

/* --largura-pagina: a página que tem o conteúdo mais largo (a Sustentabilidade,
   1400px) define a variável, e a capa acompanha. As outras ficam nos 1200px. */
const largura = `
  width: 100%;
  max-width: var(--largura-pagina, 1200px);
  margin-inline: auto;
  padding-inline: clamp(1rem, 4vw, 2.5rem);
  box-sizing: border-box;
`;

/* Página sem foto de capa: só o breadcrumb, no fundo da página, como na
   galeria. Nada de bloco verde nem título: o conteúdo vem logo abaixo. */
export const SoTrilha = styled.div`
  padding-top: clamp(1.25rem, 2.5vw, 1.75rem);
  padding-bottom: 0.5rem;
  ${largura}
`;

export const Topo = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 0;
  right: 0;
  z-index: 2;
  ${largura}

  @media (max-width: 720px) {
    top: 1rem;
  }
`;

export const Conteudo = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding-bottom: clamp(2.5rem, 5vw, 4rem);
  ${largura}

  h1 {
    margin: 0;
    max-width: 24ch;
    font-size: clamp(2.25rem, 1rem + 4vw, 4rem);
    font-weight: 700;
    line-height: 1.04;
    letter-spacing: -0.01em;
    color: #fff;
    text-wrap: balance;
  }

  > p {
    margin: 0;
    max-width: 52ch;
    font-size: clamp(0.9375rem, 0.85rem + 0.3vw, 1.0625rem);
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.92);
    text-wrap: pretty;
  }
`;

/* Selo opcional acima do título: verde da Copasul quase sólido, com um ponto
   âmbar. */
export const Selo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.45rem 1.1rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 9999px;
  background: rgba(10, 58, 31, 0.85);
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.6;

  &::before {
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: var(--sixth-color);
  }
`;

export const Acoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;
